import { Button, DatePicker, Input, Pagination, Popconfirm, notification } from 'antd';
import viVN from 'antd/es/date-picker/locale/vi_VN';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import * as PrintService from '../../../../services/printService';
import * as Actions from '../../../../libs/actions';
import * as InHospitalService from '../../../../services/inPatientService';
import * as SystemConfig from '../../../../configure/systemConfig';
const { RangePicker } = DatePicker;
function ListPaidRefund(props) {
    const [listHoaDon, setListHoaDon] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [key, setKey] = useState('');
    const [currentSize, setCurrentSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [ngay, setNgay] = useState([moment(), moment()]);
    useEffect(() => {
        if (currentPage === 0)
            return;
        GetListHoanTraTamUngByDate();
    }, [currentPage, currentSize])
    useEffect(() => {
        GetListHoanTraTamUngByDate();
    }, []);
    const GetListHoanTraTamUngByDate = () => {
        Actions.setLoading(true);
        InHospitalService.GetListHoanTraTamUngByDate(ngay[0].format("YYYY/MM/DD"), ngay[1].format("YYYY/MM/DD"), key, currentPage, currentSize).then(result => {
            if (result.isSuccess) {
                setTotalRecords(result.totalRecords);
                setListHoaDon(result.data)
            }
            else {
                Actions.openMessageDialog("Lỗi", result.err.msgString);
            }
            Actions.setLoading(false);
        }).catch(err => {
            Actions.setLoading(false);
            Actions.openMessageDialog("Lỗi", err);
        })
    }
    const printImprestFund = (id) => {
        PrintService.PrintRefundInPatient(id).then((result) => {
            Actions.DoPrint(result.item)
        })
    }
    const DeleteTamUng = (id) => {
        Actions.setLoading(true);
        InHospitalService.DeleteHoanTraTamUng(id).then(result => {
            if (result.isSuccess) {
                notification.success({ message: "Xóa thành công" });
                GetListHoanTraTamUngByDate();
            }
            else {
                Actions.openMessageDialog("Lỗi", result.err.msgString);
            }
            Actions.setLoading(false);
        }).catch(err => {
            Actions.setLoading(false);
            Actions.openMessageDialog("Lỗi", err);
        })
    }
    return (
        <React.Fragment>
            <div className="row" style={{ placeContent: 'center' }}>
                <div className="col-auto py-1" style={{ width: '250px' }}>
                    <RangePicker format="DD-MM-YYYY" value={ngay} allowClear={false}
                        locale={viVN} onChange={(value => setNgay(value))}
                    />
                </div>
                <div className="col-auto py-1">
                    <Input placeholder="Nhập số hóa đơn, tên, mã bệnh nhân"
                        type="text" style={{ width: '250px' }} value={key} onChange={(e) => { setKey(e.target.value) }} />
                    <Button className="btn btn-color"
                        onClick={() => {
                            setCurrentPage(0);
                            setTimeout(() => {
                                setCurrentPage(1);
                            }, 100);
                        }}
                    ><i className="fa fa-search"></i></Button>
                </div>
            </div>
            <div className="row">
                <div className="col-12 py-1">
                    <div className="table-responsive table-inpatient">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: '110px' }}>Ngày</th>
                                    <th style={{ minWidth: '100px' }}>Số HĐ</th>
                                    <th style={{ minWidth: '80px' }}>Mã BN</th>
                                    <th style={{ minWidth: '150px' }}>Tên BN</th>
                                    <th style={{ minWidth: '100px' }}>Số tiền</th>
                                    <th style={{ minWidth: '100px' }}>Lý do</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {listHoaDon.map((row, index) =>
                                    <tr key={index}>
                                        <td>{moment(row.ngay).format(SystemConfig.FORMAT_DATE_TIME)}</td>
                                        <td>{row.sohd}</td>
                                        <td>{row.mabn}</td>
                                        <td>{row.tenbn}</td>
                                        <td className="text-right">{row.tongtien.toLocaleString('en-US')}</td>
                                        <td>{row.lydomiengiam}</td>
                                        <td className="d-flex" style={{ width: '110px' }}>
                                            <button className="btn btn-outline-secondary mr-2" onClick={() => { printImprestFund(row.id) }} title="In">
                                                <i className="fa fa-print"></i>
                                            </button>
                                            <Popconfirm title="Xác nhận xóa tạm ứng?"
                                                onConfirm={() => { DeleteTamUng(row.id) }} okText="Đồng ý" cancelText="Hủy">
                                                <button className="btn btn-danger mr-2" onClick={() => { }} title="In">
                                                    <i className="fa fa-trash"></i>
                                                </button>
                                            </Popconfirm>
                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        style={{ textAlignLast: 'center', marginTop: 10 }}
                        total={totalRecords}
                        showTotal={total => `Tổng: ${total}`}
                        current={currentPage}
                        size={currentSize}
                        onChange={(page, size) => {
                            setCurrentPage(page);
                            setCurrentSize(size);
                        }}
                        onShowSizeChange={(page, size) => {
                            setCurrentPage(1);
                            setCurrentSize(size);
                        }
                        }
                        showSizeChanger={true}
                    />
                </div>
            </div>

        </React.Fragment>
    )
}

export default ListPaidRefund;
